<script setup lang="ts">
import { ProductsSliderLastSeen, ProductsSliderPopular } from '~/features/products-sliders';
import { MMContainer } from '@mm-frontend/mm-web-ui-kit';
import { EEmptyPageImg, EmptyPage } from '~/components';
import { useRouter } from 'vue-router';

const router = useRouter();

function goToMain() {
  router.push('/');
}
</script>

<template>
  <MMContainer class="product-not-found">
    <EmptyPage
      :empty-page-img="EEmptyPageImg.NO_PRODUCT"
      buttonText="На главную"
      title="Товар не найден"
      text="Посмотрите другие товары в каталоге или воспользуйтесь поиском"
      @emptyPageClick="goToMain"
    />

    <ProductsSliderPopular />
    <ProductsSliderLastSeen />
  </MMContainer>
</template>

<style lang="stylus" scoped>
.product-not-found
  display flex
  flex-direction column
  gap 16px
</style>
